module.exports = __webpack_public_path__ + "img/head-end-cover.010d4200.jpg";